import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { HOME } from "@/constants/testIds";

const SHARE_URL = "https://biasbuster.org";
const SHARE_TEXT = "Bias Buster (BBAP) tracks bias in people, businesses, and neighborhoods, and builds real accountability. Join the movement:";

export function ShareMovementButton({ testId, className = "" }) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const handleCopyLink = async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(SHARE_URL);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        setOpen(false);
      }, 1200);
    } catch (err) {
      setCopied(false);
      setOpen(false);
    }
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button size="lg" variant="outline" data-testid={testId} className={className}>
          <Share2 className="h-4 w-4 mr-2" /> Share the Movement
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="bg-white border-zinc-200 text-zinc-950 rounded-sm">
        <DropdownMenuItem asChild className="cursor-pointer focus:bg-zinc-100">
          <a
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(SHARE_URL)}`}
            target="_blank" rel="noopener noreferrer" data-testid={HOME.shareTwitter}
          >
            Share on X / Twitter
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="cursor-pointer focus:bg-zinc-100">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}`}
            target="_blank" rel="noopener noreferrer" data-testid={HOME.shareFacebook}
          >
            Share on Facebook
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={handleCopyLink} data-testid={HOME.shareCopyLink} className="cursor-pointer focus:bg-zinc-100">
          {copied ? (<><Check className="h-4 w-4 mr-2" /> Copied!</>) : (<><Copy className="h-4 w-4 mr-2" /> Copy Link</>)}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
